import { Component,OnInit,OnDestroy,AfterViewInit } from '@angular/core';
import { takeWhile } from "rxjs/operators";
import { RxStompState } from "@stomp/rx-stomp";

import {
    FvmsCommonService
    ,FvmsApiDtgWsProcessorService
    ,FilterDateTime
    ,FvmsApiDtgAddrService
} from "src/app/shared";

@Component({
    templateUrl: './packet.realtime.component.html'
    ,styleUrls: ["./packet.realtime.component.scss"]
    ,providers: [FilterDateTime]
})
export class DtgPacketRealtimeComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    filterKey:string;
    listPacket:any[] = [];
    listBody:any[] = [];
    selectedBody:string = null;
    subscriptionPacketLogProcess:any;
    connectionStateMessageProcess:string = "접속 해제";
    connectionStateMessageClassProcess:string = "btn-secondary";
    dtgGpsLat:string = "33.5039818";
    dtgGpsLng:string = "126.5062336";
    dtgGpsAddr:string;
    
    constructor(
        private fvmsCommonService:FvmsCommonService
        ,private fvmsApiDtgWsProcessorService:FvmsApiDtgWsProcessorService
        ,private fvmsApiDtgAddrService:FvmsApiDtgAddrService
    ) {
        
    }

    ngOnInit() {
        this.fvmsApiDtgWsProcessorService.connect()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe((state) => {
                console.log("fvmsApiDtgWsProcessorService","status",RxStompState[state]);
                switch(state){
                    case RxStompState.OPEN:
                        this.connectionStateMessageProcess = "접속 완료";
                        this.connectionStateMessageClassProcess = "btn-success";
                        break;
                    case RxStompState.CONNECTING:
                        this.connectionStateMessageProcess = "접속중";
                        this.connectionStateMessageClassProcess = "btn-info";
                        break;
                    case RxStompState.CLOSING:
                        this.connectionStateMessageProcess = "접속 해제중";
                        this.connectionStateMessageClassProcess = "btn-warning";
                        break;
                    case RxStompState.CLOSED:
                    default:
                        this.connectionStateMessageProcess = "접속 해제";
                        this.connectionStateMessageClassProcess = "btn-secondary";
                        break;
                }
            });
        
        this.subscriptionPacketLogProcess = this.fvmsApiDtgWsProcessorService.subscribePacketLog()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe((message) => {
                let packet = JSON.parse(message.body);
                // console.log("fvmsApiDtgWsProcessorService","subscribePacketLog",packet);
                this.listPacket.push(packet);
                this.listPacket = this.listPacket.slice(0,100);
            });
    }

    ngOnDestroy() {
        this.isContinue = false;
        this.fvmsApiDtgWsProcessorService.disconnect();
    }
    
    ngAfterViewInit() {
        
    }

    clickItemPacket(item){
        this.listBody = JSON.parse(JSON.stringify(item.listBody));
    }

    clickItemPacketBody(item){
        this.selectedBody = JSON.stringify(item,null,2);
    }

    clickFindAddr(){
        this.fvmsApiDtgAddrService.getAddressByLatLng(this.dtgGpsLat,this.dtgGpsLng)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    // console.log("clickFindAddr",apiResponse.resultValue);
                    if(apiResponse.resultValue){
                        this.dtgGpsAddr = apiResponse.resultValue.dtgGpsAddr;
                    }
                }
            });
    }
}